<p-dialog
  [(visible)]="display"
  header="{{ 'label.EditTransaction' | translate }}"
  (onHide)="onCancel()"
  appendTo="body"
  modal="true"
  [style]="{ width: '400px' }"
>
  <div>
    <span
      >{{ 'label.TransactionCode' | translate }}:
      <b>{{ transaction?.code }}</b></span
    ><br /><br />
    <span
      >{{ 'label.TransactionDate' | translate }}:
      <b>{{ transaction?.createDate }}</b></span
    ><br /><br />
    <span
      >{{ 'label.Customer' | translate }}:
      <b>{{ transaction?.customerName }}</b></span
    ><br /><br />
    <div>
      {{ 'label.Payer' | translate }}:
      <p-autoComplete
        [(ngModel)]="editSubmitData.payerAccount"
        [suggestions]="payersList"
        (completeMethod)="filterPayer($event)"
        appendTo="body"
        [minLength]="1"
        [inputStyle]="{ width: '100%' }"
      >
        <ng-template let-payer pTemplate="item">
          <span>{{ payer.label }}</span>
        </ng-template>
      </p-autoComplete>
    </div>
    <span
      >{{ 'label.OrderTotal' | translate }}:
      <b>{{ transaction?.orderTotalAmount }}</b></span
    ><br /><br />
    <div>
      {{ 'label.InvoiceAmount' | translate }}:
      <input type="text" [(ngModel)]="editSubmitData.invoiceAmount" />
    </div>
    <div>
      {{ 'label.PaymentType' | translate }}:
      <select
        [ngModel]="paymentMethods && editSubmitData.paymentType"
        (ngModelChange)="
          paymentMethods && (editSubmitData.paymentType = $event)
        "
        [disabled]="
          transaction?.approvalStatusId ==
          transactionApprovalStatusEnum.FinalApprove
        "
      >
        <option *ngFor="let type of paymentMethods" [ngValue]="type?.value">
          {{ type?.label }}
        </option>
      </select>
    </div>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="onSave()"
      label="{{ 'label.Save' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
